import { cx } from '@/lib/cx';
import styles from './CurveDivider.module.css';

export interface CurveDividerProps {
  /** `down` la curva cae (final de hero) · `up` la curva sube. */
  direction?: 'down' | 'up';
  /** Color de relleno de la curva: el de la seccion que viene DESPUES. */
  fill?: 'surface' | 'alt' | 'cool' | 'aqua';
  /** Linea dorada siguiendo el borde, como en el hero del hub. */
  withGoldEdge?: boolean;
  className?: string;
}

/**
 * Separador curvo suave entre secciones — el rasgo que cose todos los mockups.
 * Es un SVG a sangre con `preserveAspectRatio="none"`: se estira al ancho del
 * viewport sin pixelar y sin generar scroll horizontal.
 */
export function CurveDivider({
  direction = 'down',
  fill = 'surface',
  withGoldEdge = true,
  className,
}: CurveDividerProps) {
  const path =
    direction === 'down'
      ? 'M0 42 C 240 96, 420 8, 720 22 C 1020 36, 1200 96, 1440 52 L1440 120 L0 120 Z'
      : 'M0 78 C 240 24, 420 112, 720 98 C 1020 84, 1200 24, 1440 68 L1440 0 L0 0 Z';
  const edge =
    direction === 'down'
      ? 'M0 42 C 240 96, 420 8, 720 22 C 1020 36, 1200 96, 1440 52'
      : 'M0 78 C 240 24, 420 112, 720 98 C 1020 84, 1200 24, 1440 68';

  return (
    <svg
      className={cx(styles.curve, styles[`fill-${fill}`], className)}
      viewBox="0 0 1440 120"
      preserveAspectRatio="none"
      aria-hidden="true"
      focusable="false"
    >
      <path className={styles.body} d={path} />
      {withGoldEdge ? <path className={styles.edge} d={edge} /> : null}
    </svg>
  );
}
